import React from 'react';

import Screen from './Screen';

export const withScreen =
  (config = {}) =>
  (BaseComponent) =>
    React.forwardRef(
      (
        {
          children,
          name = config.name,
          reducer = config.reducer,
          padding = config.padding,
          ...props
        },
        _ref
      ) => {
        return (
          <Screen name={name} reducer={reducer} padding={padding}>
            {(screenProps) => (
              <BaseComponent name={name} {...props} {...screenProps}>
                {children}
              </BaseComponent>
            )}
          </Screen>
        );
      }
    );

export default withScreen;
